<template>
  <div :style="style" id="Login">
    <div class="login-warp">
      <div class="loginCon">
        <div class="left">
          <!--<img :src="PCBanner?PCBanner:loginImg" alt="">-->
          <img :src="PCBanner" alt="">
        </div>
        <div class="right">
          <div class="form">
            <h3 style="text-align:center">欢迎您登录展商服务平台</h3>
            <el-form :model="loginForm" ref="loginForm" :rules="rules">
              <p class="formItemT">用户名</p>
              <el-form-item prop="loginName">
                <el-input prefix-icon="el-icon-user" v-model="loginForm.loginName"></el-input>
              </el-form-item>
              <p class="formItemT">密码</p>
              <el-form-item prop="loginPwd">
                <el-input prefix-icon="el-icon-lock" show-password type="password" v-model="loginForm.loginPwd"></el-input>
              </el-form-item>
            </el-form>
            <div class="btnCollect">
              <el-button @click="login()" :style="buttonStyle" type="primary">登录</el-button>
              <!-- <el-button @click="navTo()" :style="buttonStyle" type="primary">注册</el-button> -->
            </div>
            <!-- <div class="flex space-between mt10">
              <el-link :underline="false" @click="$router.push('/regist')" type="info">注册</el-link>
              <el-link :underline="false" @click="$router.push('/regist')" type="info">忘记密码</el-link>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!--<div class="tipBtn" @click="dialogVisible=true">参展商承诺</div>-->

    <el-dialog
      title="“三个承诺”之参展商承诺"
      :visible.sync="dialogVisible"
      top='10vh'
      width="45%"
      center
    
      :close-on-click-modal='isClose'
      :close-on-press-escape='isClose'
      :modal-append-to-body='isClose'
      :append-to-body='isClose'
      :lock-scroll='isClose'>
      <div>
        <div class="tipContent">
          <div class="tipItem">本人承诺：主动上报本人与其他单位、个人等主体间发生的尚未处理完毕的各类矛盾纠纷，积极配合本人所在地司法调解部门做好矛盾纠纷化解工作，不得将矛盾纠纷带到展会现场，如因本人未如实上报相关情况，造成展会现场发生滋事扰序等情况的，本人愿意承担相关法律责任。</div>
          <div class="tipItem">本人承诺：切实提高安全防范意识，全民参与防范电信网络诈骗，不听、不信、不转账，不贪、不要、不上当，一旦难分真假，务必第一时间拨打国展派出所电话021-59720110咨询求助。</div>
          <div  class="tipItem">本人承诺：严格遵守国展中心禁限带物品进馆要求，不得将明文规定的禁限带物品和与此次展会活动无关的物品带入场馆，如有违反本人愿意承担相关法律责任。注：禁带物品是指违反中国法律法规的物品；限带物品是指虽然不违反中国法律法规，但可能影响国展中心安全和运营秩序，不得带入的物品。展品中如有刀具等涉及禁、限带物品的，要在展品进入国展中心前以书面形式（包括种类数量、入场时间、安全管理措施等）向安保部门备案。</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" >我已阅读</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import { mapState } from 'vuex'
// import bgImg from '@/assets/login-bg.png'
import bgImg from '@/assets/loginBg.jpg'
import loginImg from '@/assets/login-img.png'
import sybg from '@/assets/sybg.png'
import api from '../api'
import tools from '../utils/tools.js'
export default {
  data() {
    return {
      loginForm: {},
      style: {
        background: `#fff url(${bgImg}) center/cover no-repeat`
      },
      formBg: {
        background: `url(${sybg}) repeat`
      },
      rules: {
        loginName: [
          {
            required: true,
            message: '用户名不能为空',
            trigger: 'change'
          }
        ],
        loginPwd: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'change'
          }
        ]
      },
      loginImg: loginImg,
      exhName: '',
      PCBanner: '',
      buttonStyle: null,
      isClose:false,
      dialogVisible:false
    }
  },
  computed: {
    ...mapState('status', {
      lg: (state) => {
        const lg = {
          right: {
            offset: 16,
            span: 6
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return lg[state.login.formPosition]
      },
      sm: (state) => {
        const sm = {
          right: {
            offset: 14,
            span: 8
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return sm[state.login.formPosition]
      },
      xl: (state) => {
        const xl = {
          right: {
            offset: 16,
            span: 4
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return xl[state.login.formPosition]
      }
    })
  },
  mounted() {
   localStorage.setItem('ExhID', this.$route.query.ExhID)
   this.getexhinfo()
   this.getselfbasicfield()
  },

  watch: {},
  methods: {
    getselfbasicfield () {
      api.getselfbasicfield({
        exhId: this.ExhID
      }).then(res => {
        if (res.data.code === 200) {
          var _data = res.data.data
          for (var i = 0; i < _data.length; i++) {
            sessionStorage.setItem(_data[i].scKey, _data[i].scValue)
          }
          this.PCBanner = sessionStorage.getItem('PCBanner')
          // this.bannerUrl = sessionStorage.getItem('banner') || ''
          this.buttonStyle = sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
        } else {
          this.$toast.fail(res.data.msg)
        }
      })
    },
    getexhinfo() {
      api.getexhinfo().then(res => {
        if (res.data.code === 200) {
          sessionStorage.setItem('exhName', res.data.data.exhName)
          this.exhName = res.data.data.exhName
          document.title = `${sessionStorage.getItem('exhName')}展商自助服务平台`;
        }
      })
    },
    navTo() {
      this.$router.push(`/singUp`)
    },
    login() {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          api.login(this.loginForm).then((res) => {
            if (res.data.code === 200) {
              res.data.data.loginTime = new Date().getTime()
              localStorage.setItem('userInfo', JSON.stringify(res.data.data))
              localStorage.setItem('atrName', res.data.data.atrName)
              localStorage.setItem('atrEName', res.data.data.atrEName)
              localStorage.setItem('token', res.data.data.token)
              localStorage.setItem('loginName', this.loginForm.loginName)
              sessionStorage.setItem('knowwrap', res.data.data.atrLeaderLinkInfo)
              sessionStorage.setItem('soundwrap', res.data.data.atrLabel2)
              sessionStorage.setItem('bthArea', res.data.data.bthArea)
              if(res.data.data.exhID){
                localStorage.setItem('ExhID', res.data.data.exhID)
              }
              
              
              // api.setHeader()
              this.$router.push('/landingPage')
              // this.$router.push('/boothBook')
            }
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tipBtn{
  position: fixed;
  background:#409EFF;
  color:#fff;
  top:10%;
  right:0;
  font-size:16px;
  padding:16px 26px;
  cursor: pointer;
  z-index: 1111;
}
#Login {
  height: 100%;
  .login-warp {
    width: 980px;
    margin: 0 auto;
    padding: 60px 0 60px;
    position: relative;
    .loginCon{
      border-radius: 12px;
      overflow: hidden;
      position: relative;
      background: #fff;
      display: flex;
    }
    .left{
      // float: right;
      // width: 43%;
      // position: absolute;
      // left: 0;
      // top: 0;
      // height: 100%;
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: cover;
      img{
        height: 650px;
        width: 100%;
      }
    }
    .right{
      // float: right;
      width: 480px;
      height: inherit;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 40px 0;
      position: relative;
    }
    .form {
      padding: 30px 60px 20px;
      border-radius: 4px;
      h3{
        text-align: left;
        padding-bottom: 50px;
        font-size: 20px;
        font-weight: 600;
      }
      .formItemT{
        font-weight: 400;
        font-size: 12px;
        padding: 0;
        line-height: 30px;
        width: 100%;
        display: inline-block;
      }
      .btnCollect{
        padding:45px 0 20px;
        .el-button{
          width: 100%;
          margin:16px 0;
        }
      }
    }
  }
  .tipContent{
    line-height: 30px;
    font-size:16px;
    .tipItem{
      padding-bottom: 10px;
      text-indent: 32px;
    }
  }
}
</style>
